function RateSchedule(aBilling) {
    "use strict";
    this.__type = 'RateSchedule:www.veritracks.com';
    this.RateScheduleId = -1;
    this.ProductId = -1;
    this.DeviceModeId = -1;
    this.ProductDailyRate = 0;
    this.Id = 0;

    if (aBilling) {
        this.RateScheduleId = aBilling.RateScheduleId;
        this.ProductId = aBilling.ProductId;
        this.DeviceModeId = aBilling.DeviceModeId;
        this.ProductDailyRate = aBilling.ProductDailyRate;
    }


}
if (typeof exports !== 'undefined') {
    module.exports = RateSchedule;
}